import {FC, PropsWithChildren, useEffect} from 'react';

import useConfigStore from '@common/stores/configStore';
import {selectIsLoading, selectIsConfigLoaded} from '@common/stores/configSelectors';

const ConfigLoader: FC<PropsWithChildren> = ({children}) => {
  const {loadConfig} = useConfigStore();
  const isLoading = useConfigStore(selectIsLoading);
  const isConfigLoaded = useConfigStore(selectIsConfigLoaded);

  useEffect(() => {
    if (!isLoading && !isConfigLoaded) {
      loadConfig();
    }
  }, []);

  return isConfigLoaded ? children : null;
};

export default ConfigLoader;
